import { getInitialState } from './index';
import { State, Rooms, Room } from './types';
import { transformServerRooms } from './utils';

const mutations = {
  setRooms(state: State, rooms: Rooms) {
    state.rooms = rooms;
  },
  setIsLoading(state: State, isLoading: boolean) {
    state.isLoading = isLoading;
  },
  resetRoomsState(state: State) {
    Object.assign(state, getInitialState());
  },
  updateRoom(state: State, updatedRoom: Room) {
    const transformedRoom: Rooms = transformServerRooms([updatedRoom]);
    state.rooms = {
      ...state.rooms,
      [updatedRoom.id]: transformedRoom[updatedRoom.id]
    };
  },
  deleteRoom(state: State, roomId: string) {
    const rooms = { ...state.rooms };
    delete rooms[roomId];
    state.rooms = rooms;
  },
  reorderRooms(state: State, rooms: Room[]) {
    const reorderRank: Room[] = rooms.map((room, index) => {
      return {
        ...room,
        rank: index
      };
    });
    const transformedRooms = transformServerRooms(reorderRank);
    state.rooms = transformedRooms;
  }
};

export default mutations;
